<div class="split-column">
  <div class="column">
    <ng-content select="[left]"></ng-content>
  </div>

  <div class="column">
    <ng-content select="[right]"></ng-content>
  </div>
</div>
